import React, { useState, useEffect } from 'react';
import { change } from 'redux-form';
import PropTypes from 'prop-types';
import ServiceGroup from './ServiceGroup';

import {
  checkForHeavyItems, accessorialsMapping, checkSpecialCases, checkForLargeItems,
} from './methods';

const AccessorialsPicker = (props) => {
  const {
    source,
    isUSShipment,
    isUSConsignee,
    formName,
    shipperIsResidential,
    consigneeIsResidential,
    formData,
    hasDangerousGoods,
    dispatch,
    fieldsShouldBeBlocked,
  } = props;

  const [specialCases, setSpecialCases] = useState();
  const [accessorials, setAccessorials] = useState(null);

  const isResidential = (shipperIsResidential || consigneeIsResidential);
  const hasHeavyItems = checkForHeavyItems(formData);
  const hasLargeItems = checkForLargeItems(formData);

  useEffect(() => {
    const accessorialsObj = accessorialsMapping(source);
    const accList = {};
    accessorialsObj.services.forEach((service) => {
      accList[service.idx] = { ...service, selected: false };
    });

    setAccessorials(accessorialsObj);
  }, [source]);

  useEffect(() => {
    const cases = checkSpecialCases(isUSShipment, isUSConsignee, hasHeavyItems, hasLargeItems, shipperIsResidential, consigneeIsResidential);
    const {
      hasPRESPU, hasPRESDL, hasCPASC, has63,
    } = cases;

    if (hasDangerousGoods) {
      dispatch(change(formName, 'accessorials.accHAZMAT.selected', true));
    }

    if (hasPRESPU) {
      dispatch(change(formName, 'accessorials.accPRESPU.selected', true));
    }

    if (hasPRESDL) {
      dispatch(change(formName, 'accessorials.accPRESDL.selected', true));
    }

    if (hasCPASC) {
      dispatch(change(formName, 'accessorials.accCPASC.selected', true));
    }

    if (has63) {
      dispatch(change(formName, 'accessorials.acc63.selected', true));
    } else {
      dispatch(change(formName, 'accessorials.acc63.selected', false));
    }

    setSpecialCases(cases);
  }, [isUSShipment, isUSConsignee, hasHeavyItems, shipperIsResidential, consigneeIsResidential, hasLargeItems]);

  if (!accessorials) {
    return null;
  }

  return (
    <>
      {accessorials.groups.map((group, index) => {
        const servicesList = accessorials.services.filter((item) => item.groupId === group.id);

        return (
          <ServiceGroup
            key={`group-${index}-${group.name}`}
            group={group}
            formData={formData.accessorials}
            services={servicesList}
            isUSShipment={isUSShipment}
            specialCases={specialCases}
            isResidential={isResidential}
            hasHeavyItems={hasHeavyItems}
            hasDangerousGoods={hasDangerousGoods}
            fieldsShouldBeBlocked={fieldsShouldBeBlocked}
          />
        );
      })}
    </>
  );
};

AccessorialsPicker.propTypes = {
  source: PropTypes.object,
  isUSShipment: PropTypes.bool,
  isUSConsignee: PropTypes.bool,
  consigneeIsResidential: PropTypes.bool,
  formName: PropTypes.string,
  shipperIsResidential: PropTypes.bool,
  formData: PropTypes.object,
  hasDangerousGoods: PropTypes.bool,
  dispatch: PropTypes.func,
  fieldsShouldBeBlocked: PropTypes.bool,
};

export default AccessorialsPicker;
